var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-control-btn"},[_c('div',{staticClass:"control-btn pause-btn",class:{ 'is-paused': _vm.status === 'pause' },on:{"click":_vm.togglePause}}),_c('div',{staticClass:"control-btn volume-btn",class:{ 'is-muted': _vm.isMuted },on:{"click":_vm.toggleMute}})])
}
var staticRenderFns = []

export { render, staticRenderFns }